<script setup lang="ts">
import type { ModelRef } from "vue";
import { UserColumns } from "~/modules/user/models/UserColumns.enum";

const { t } = useI18n();

defineProps<{
  businessUnitCode: number;
  pathContext: string;
}>();

const showUserForm: ModelRef<boolean> = defineModel<boolean>("showUserForm", {
  required: true,
});
const currentSelectedUser: ModelRef<string | undefined> = defineModel<
  string | undefined
>("currentSelectedUser");
</script>

<template>
  <h4 class="mb-5 text-gray-900">
    {{ t("administration.businessUnit.settings.users.title") }}
  </h4>
  <user-list
    v-model:show-user-form="showUserForm"
    v-model:current-selected-user="currentSelectedUser"
    :business-unit-code="businessUnitCode"
    :columns="[
      UserColumns.LAST_NAME,
      UserColumns.FIRST_NAME,
      UserColumns.PROFILE,
      UserColumns.EMAIL,
      UserColumns.STATUS,
    ]"
    :path-context="pathContext"
  />
</template>
